import React, { useEffect, useState } from 'react';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@uhg-abyss/web/ui/Button';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { validateCase, saveValidation } from '../../service/validateService';
import FileData from '../FileData/FileData';

export const ValidateCase = () => {
  const [caseIds, setCaseIds] = useState<string[]>([]);
  const [selectedCaseId, setSelectedCaseId] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    fetch('/caseids.json')
      .then((res) => res.json())
      .then((data) => setCaseIds(data))
      .catch((err) => console.error('Failed to load case IDs', err));
  }, []);

  const handleSearch = async () => {
    if (!selectedCaseId) return;

    setLoading(true);
    setResult(null);
    setError(null);
    setIsSubmitted(true);

    try {
      const data = await validateCase(selectedCaseId);
      console.log('Validate result keys:', Object.keys(data));
      console.log('triage_information type:', typeof data.triage_information);
      console.log('summary type:', typeof data.summary);

      const triage = typeof data.triage_information === 'string'
        ? JSON.parse(data.triage_information)
        : data.triage_information || {};

      const summary = typeof data.summary === 'string'
        ? JSON.parse(data.summary)
        : typeof data.descriptive_summary === 'string'
          ? JSON.parse(data.descriptive_summary)
          : data.summary || data.descriptive_summary || {};

      setResult({ triage_information: triage, descriptive_summary: summary });
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Failed to validate case'
      );
    } finally {
      setLoading(false);
    }
  };

  const menuItems = caseIds.map((id) => ({
    title: id,
    onClick: () => { setSelectedCaseId(id); setIsSubmitted(false); },
  }));

  return (
    <Layout.Stack style={{ maxWidth: 'fit-content', margin: '0 auto', padding:'20px'}}>
      <h2>Validate Case</h2>
      <Layout.Stack>
        <DropdownMenu
          label={selectedCaseId || 'Select a Case ID'}
          menuItems={menuItems}
        />
        <Button
          onClick={handleSearch}
          disabled={!selectedCaseId || loading}
          isDisabled={!selectedCaseId || isSubmitted || loading}
          isLoading={loading}
        >
          Search
        </Button>
      </Layout.Stack>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <LoadingSpinner
            size="lg"
            isLoading={loading}
            ariaLoadingLabel="Validating Case"
          />
        </div>
      )}

      {error && (
        <div style={{ color: 'red', padding: '12px', border: '1px solid red', borderRadius: '4px' }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {result && (
        <FileData
          file={result}
          onEditChange={() => {}}
          onSave={async (section, updatedData) => {
            try {
              await saveValidation(selectedCaseId, section, updatedData);
              setResult((prev) => ({
                ...prev,
                ...(section === 'triage'
                  ? { triage_information: updatedData }
                  : { descriptive_summary: updatedData }),
              }));
            } catch (err) {
              console.error('Failed to save:', err);
              setError(err.message || 'Failed to save changes');
            }
          }}
        />
      )}
    </Layout.Stack>
  );
};
